import { Content } from './content';

export class MessageSimple extends Content{

  legacy: boolean = false; // 旧フォームの場合:true ※trueの場合、変更不可、保存しない
  type:'MessageSimple';
  typeText:string;
  title:string;
  description:string;
  
  constructor(object = null){
    super();

    this.type = 'MessageSimple';

    if(object){
      super.set(object);
      this.set(object);
    }
  };

  set(object){
    super.set(object);

    if(object.legacy){
      this.legacy = object.legacy;
    }

    if(object.hash){
      this.hash = object.hash;
    }
    if(object.title){
      this.title = object.title;
    }
    if(object.description){
      this.description = object.description;
    }

  }


}